import React from 'react'
import { AccountManagement as AccountManagementController } from '../../components/AccountManagement'

export const AccountManagement = (props) => {
  return (
    <>
      <AccountManagementController {...props} />
    </>
  )
}
